export const cse_logos_colored = [
    
    {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/css_effort/SDG_1_k3tbx3.svg",
       "name":"No Poverty SDG 1",
    },

    {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/css_effort/SDG_2_ly7lhl.svg",
       "name":"Zero Hunger SDG 2",
    },

    {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/css_effort/SDG_4_maeok1.svg",
       "name":"Universal Education SDG 4",
    },

     {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/css_effort/SDG_5_axrln5.svg",
       "name":"Gender Equality SDG 5",
    },

      {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/css_effort/SDG_6_duum43.svg",
       "name":"Clean Water And Sanitation SDG 6",
    },

    {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/css_effort/SDG_8_mqp4bk.svg",
       "name":"Decent Work And Economic Growth SDG 8",
    },

    {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/css_effort/SDG_10_c3kpiu.svg",
       "name":"Reduced Inequalities SDG 10",
    },

    {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/css_effort/SDG_11_gw8tn6.svg",
       "name":"Sustainable Cities And Communities SDG 11",
    },
    
    {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/css_effort/SDG_17_qvtgvt.svg",
       "name":"Partnerships For The Goals SDG 17",
    },
    

]

export const key_sectors_icon_blue = [
    
   {
      "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/key_sector/Information_Technology_dymrqt.svg",
      "name":"Information Technology",
   },
   {
      "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/key_sector/Electronics_hex7t5.svg",
      "name":"Electronics",
   },
   {
      "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/key_sector/Travel_Tourism_xit32y.svg",
      "name":"Travel & Tourism",
   },
   {
      "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/key_sector/Retail_two_mpa5hd.svg",
      "name":"Retail",
   },
   {
      "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/key_sector/Networking_naz3dd.svg",
      "name":"Networking",
   },
   {
      "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/key_sector/Hospitality_two_wugvsk.svg",
      "name":"Hospitality",
   },
   {
      "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/key_sector/Agriculture_djl0hx.svg",
      "name":"Agriculture",
   },
   {
      "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/key_sector/Mobile_Laptop_Repairing_kpgknz.svg",
      "name":"Mobile, Laptop Repairing",
   },
    {
      "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/key_sector/Healthcare_three_tntmto.svg",
      "name":"Healthcare",
   },
   {
      "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/key_sector/Appareal_ttwjkv.svg",
      "name":"Apparel Manufacturing",
   }
   

]

export const csrLogos = [
  {link:'https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/client_partner/image002_lcxltg.jpg' },
  {link:'https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/client_partner/8_REC_Ltd_badoj0.png' },
  {link: 'https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/client_partner/14_Samsung_e5qc8n.png'},
  {link: 'https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/client_partner/13_ICICI_Foundation_j1jusg.jpg'},
  {link: 'https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/client_partner/12_Diageo_fmtdyx.png'},
  {link: 'https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/client_partner/10_GE_xyyyg8.png'},
  {link: 'https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/client_partner/9_Alstompng_kmy7fn.png'},
  {link: 'https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/client_partner/7_Indian_Oil_wj4hf6.png'},
  {link: 'https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/client_partner/11_Phillips_jjkvlg.png'},
  {link: 'https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/client_partner/2_Crompton_Greaves_g1xd1s.png'},
  {link: 'https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/client_partner/6_NTPC_mmvcih.png'},
  {link: 'https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/client_partner/4_Ingersoll_Rand_n8ynaf.png'},
  {link: 'https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/client_partner/5_ITC_gx4iqi.png'},
  {link: 'https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/client_partner/3_Larson___Toubro_ypunwj.png'},
  {link: 'https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/corporate_social_responsibility/client_partner/1_HDFC_Bank_mew0nl.png'},
]

export const csrFocusGroup = [
   {
      text:"Inmates of tihar jail (with capablity and recoginition to rehabilitate themselves as a  self-relaint individual"
   },
   {
      text:'Differently abled candidates'
   },
   {
      text:'Candidates who suffer from subnormal capablities'
   },
   {
      text:'Widows of Martyrs'
   },
]

